import { Box, Hidden } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Ion } from "cesium";
import React, { useEffect } from "react";
import { setNavMenuOpen } from "~/redux/reducers/generalReducer";
import { useAppDispatch, useAppSelector } from "~/redux/store/store";
import { Routes } from "~/routes";
import { useAisVesselAlarmUpdate } from "~/store/alarmIndicatorHooks/useAisVesselAlarmUpdate";
import Header from "~/template/components/navigation/Header";
import Navigator from "~/template/components/navigation/Navigator";
import { useOnlyTLReadAccess } from "~/utils/hooks/useOnlyTLReadAccess";
import { AccessWrapper } from "./AccessWrapper";

Ion.defaultAccessToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJjMzRlMmQzYi05MGJjLTQzZmEtODIxMy00ZTVkODJjZGU5NTAiLCJpZCI6NzUxMjQsImlhdCI6MTYzODUxNTIyMX0.Lw_yrX9nRd0F4YmMZrsNZ57qnS-4tuKz38hlvg5k5dc";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "var(--full-vh, 100vh)",
    maxWidth: "100vw",
    /*     width: "100vw",
    height: "var(--full-vh, 100vh)", */
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      flexShrink: 0,
    },
  },
  app: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    /*     height: "var(--full-vh, 100vh)", */
  },
  main: {
    /* height: "100%",
    width: "100%", */
    flex: 1,
    background: theme.palette.background.paper,
  },
}));

const Root = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  useAisVesselAlarmUpdate();
  const mobileOpen = useAppSelector((x) => x.general.navMenuOpen);
  const [drawerWidth, setDrawerWidth] = React.useState(0);
  const onlyTLReadAccess = useOnlyTLReadAccess();

  // const loadingRoute = useLoadingRoute();
  useEffect(() => {
    localStorage.setItem(
      "ORIGIN",
      `${window.location.href.replace(window.location.origin, "")}`,
    );
  }, []);

  return (
    <AccessWrapper>
      <div className={classes.root}>
        {onlyTLReadAccess ? null : (
          <nav className={classes.drawer}>
            <Hidden smUp implementation="js">
              <Navigator
                variant="temporary"
                open={mobileOpen}
                onClose={() => {
                  dispatch(setNavMenuOpen(!mobileOpen));
                }}
                onSizeChange={setDrawerWidth}
              />
            </Hidden>
            <Hidden smDown implementation="css">
              <Navigator onSizeChange={setDrawerWidth} />
            </Hidden>
          </nav>
        )}
        <Box
          className={classes.app}
          sx={{ width: `calc(100% - ${drawerWidth}px)` }}
        >
          <Header
            onDrawerToggle={() => {
              dispatch(setNavMenuOpen(!mobileOpen));
            }}
          />
          {/* <Fade
          in={!!loadingRoute}
          style={{
            transitionDelay: loadingRoute ? "400ms" : "0ms",
          }}
          unmountOnExit
        >
        <LinearProgress />
        </Fade> */}
          <main className={classes.main}>
            <Routes />
          </main>
        </Box>
      </div>
    </AccessWrapper>
  );
};

export default Root;
